// Sending a booked bill's receipt to the customer on WhatsApp or by email
// (sendFashionDigitalReceipt). The server makes the same PDF it sends on
// booking when the till has eBill on, so this is for a customer who asks again
// or was added after the bill went through.
import { readMessage } from "./holds";

export const RECEIPT_CHANNELS = [
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
];

const clean = (s) => String(s ?? "").replace(/["\\]/g, "").replace(/[\r\n]+/g, " ").trim();

export const buildSendReceiptMutation = (orderId, via) => ({
  query: `mutation { sendFashionDigitalReceipt(orderId: "${clean(orderId)}", via: "${clean(via)}") { status message recordId documentNo } }`,
});

export const readSendReceipt = (response) => readMessage(response, "sendFashionDigitalReceipt", "Couldn't send the receipt. Try again.");

// A receipt goes to a named customer; the server checks the mobile or email.
export function canSendReceipt(order) {
  const c = order?.customer;
  if (!order?.sOrderID || !c) return false;
  const name = typeof c === "string" ? c : c.name;
  return Boolean(name) && name !== "Walk-in";
}
